import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeAvatarModule } from 'se-fe-avatar'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeIconModule, seFeIconSpotInviteCancel } from 'se-fe-icon'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { UnsubscribeSuccessComponent } from './unsubscribe-success/unsubscribe-success.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeAvatarModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeHeaderModule,
    SeFeIconModule.include([seFeIconSpotInviteCancel]),
    SeFeLinkModule,
    SeFeTranslationsModule
],
  declarations: [UnsubscribeSuccessComponent],
  exports: [UnsubscribeSuccessComponent],
})
export class SeHouseholdSetupFeatureUnsubscribeSuccessModule {}
